import { Component } from '@angular/core';
import { AppAnimations } from 'src/app/_shared/animations';

@Component({
  animations: [AppAnimations],
  selector: 'app-payment-operations',
  templateUrl: './payment-operations.component.html'
})

export class PaymentOperationsComponent {
  constructor() {}
}
